import { Country } from "../../../common/models/CommonModels";
import { CustomerSizeCode, CustomerTurnoverCode, FileModel, Page, PaymentMethodCode, QueryBase, ShippingOptionCode } from "../../../shared/models/models";
import { Machine, MachineType, MachinesQuery } from "../../machinery/models/models";
import { CustomerContact } from "../../shared/models/customerContactsModels";
import { CustomerIndustry, RoleCode, Warehouse } from "../../shared/models/customerModels";

export interface CustomerCompanyState {
  query: CompaniesQuery;
  companies?: Page<CustomerCompany>;
  company?: CustomerCompanyDetails;
  machines: Record<string, Machine[]>;
  machinesQuery: CompanyMachinesQuery;
  manufacturers: ManufacturerReference[];
  machineManufacturers: ManufacturerReference[];
  machineTypes: MachineType[];
  categories: CategoryReference[];
  countries: Country[];
  machineCounts: Record<string, number>;
  loading: boolean;
  tabLoading: boolean;
  success?: string;
  error: any;
}

export interface Company {
  id: string;
  name: string;
}

export interface CustomerCompany extends Company {
  logo: FileModel | null;
  address: CompanyAddress;
  categories: CategoryReference[];
  manufacturers: ManufacturerReference[]
  turnoverCode: CustomerTurnoverCode;
  sizeCode: CustomerSizeCode;
  shippingOptionCodes: ShippingOptionCode[];
  paymentMethodCodes: PaymentMethodCode[];
  hasStock?: boolean;
  hasContacts?: boolean;
  hasMachines?: boolean;
  email?: string;
  customerType?: number;
}

export interface CustomerCompanyDetails extends CustomerCompany {
  banner: FileModel | null;
  description?: string,
  roleCode: RoleCode;
  establishingYear?: string,
  website: string;
  phone?: string;
  email?: string;
  vatId: string;
  taxId: string;
  registrationNumber: string;
  customerIndustry: CustomerIndustry;
  defaultContact?: CustomerContact;
  warehouse?: Warehouse;
  isDisabled: boolean;
  createdDate: Date;
  modifiedDate: Date;
  linkedInLink: string;
  instagramLink: string;
  xLink: string;
  facebookLink: string;
}

export interface CompanyAddress {
  addressLine?: string;
  city?: string;
  countryId: number;
  countryName: string;
  zipCode?: string;
  longitude?: string;
  latitude?: string;
  distance?: number;
}

export interface ManufacturerReference {
  id: string;
  name: string;
}

export interface CategoryReference {
  id: string;
  name: string;
}

export interface CompaniesQuery extends QueryBase<CompanyQueryParameter> {
  roleCode?: RoleCode;
  countryId?: string;
  manufacturerId?: string;
  categoryId?: string;
}

export interface CompanyMachinesQuery extends MachinesQuery {
  customerId?: string;
}

export enum CompanyQueryParameter {
  name = 1,
  createdDate = 2,
  modifiedDate = 3,
  role = 4,
  disabled = 5
}
